export function LoadingDiv() {
  return <div>Loading...</div>;
}

// TODO Delete this when renaming LoadingDiv to LoadingComponent
export const LoadingComponent = LoadingDiv;
